import api, { logoutAndEndAuthSession } from './api';

const userService = {
  getAll: async () => {
    const response = await api.get('/api/private/user');
    return response.data;
  },

  getAssignable: async () => {
    const response = await api.get('/api/private/user/assignable');
    return response.data;
  },

  getAdminUsers: async () => {
    const response = await api.get('/api/private/user/admin');
    return response.data;
  },

  updateAssignable: async (id, assignable) => {
    const response = await api.patch(`/api/private/user/${id}/assignable`, { assignable });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/api/private/user/${id}`);
    return response.data;
  },

  getCurrentUser: async () => {
    const response = await api.get('/api/private/user/current');
    return response.data;
  },

  updateTicketListViewMode: async (viewMode) => {
    const response = await api.patch('/api/private/user/current/ticket-list-view-mode', {
      viewMode,
    });
    return response.data;
  },

  updateCurrentPhoto: async (imageBase64) => {
    const response = await api.patch('/api/private/user/current/photo', {
      imageBase64,
    });
    return response.data;
  },

  getCurrentPhoto: async () => {
    const response = await api.get('/api/private/user/current/photo');
    const imageBase64 = response?.data?.imageBase64;
    if (!imageBase64 || typeof imageBase64 !== 'string') {
      throw new Error('Foto não encontrada');
    }
    return imageBase64.startsWith('data:')
      ? imageBase64
      : `data:image/jpeg;base64,${imageBase64}`;
  },

  removeCurrentPhoto: async () => {
    const response = await api.delete('/api/private/user/current/photo');
    return response.data;
  },

  create: async (userData) => {
    const response = await api.post('/api/private/user/new', userData);
    return response.data;
  },

  update: async (id, userData) => {
    const response = await api.put(`/api/private/user/${id}`, userData);
    return response.data;
  },

  delete: async (id) => {
    await api.delete(`/api/private/user/${id}`);
  },

  test: async (page = 0, size = 10) => {
    const response = await api.get(`/api/private/user/test?page=${page}&size=${size}`);
    return response.data;
  },

  logout: () => logoutAndEndAuthSession()
};

export default userService; 